import React from 'react';
import {
  Route as ReactDomRoute,
  RouteProps as ReactDomRouteProps,
  Redirect,
} from 'react-router-dom';

import { useAuth } from '../hooks/FirebaseAuth';

interface RouteProps extends ReactDomRouteProps {
  isPrivate?: boolean;
  component: React.ComponentType;
}

const Route: React.FC<any> = ({
  isPrivate = false,
  component: Component,
  ...rest
}) => {
  const { getUser } = useAuth();
  const user = getUser();

  return (
    <ReactDomRoute
      {...rest}
      render={() => {
        return isPrivate && !user ? (
          <Redirect to={`/${rest.computedMatch.params.event}/signin`} />
        ) : (
          <Component {...rest} {...rest.computedMatch} />
        );
      }}
    />
  );
};

export default Route;
